import React from "react";
import { motion } from "framer-motion";
import { Sun, Inbox, Calendar, Sparkles, ArrowRight, ShieldCheck } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen w-full bg-background text-foreground grid lg:grid-cols-2 overflow-hidden">
      {/* Left — pitch */}
      <div className="relative flex flex-col justify-between p-8 sm:p-14 grain">
        <div className="relative z-10">
          <div className="font-display text-2xl font-semibold tracking-tight">AIRTIME</div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="relative z-10 max-w-xl"
        >
          <div className="font-mono text-xs uppercase tracking-widest text-primary mb-5">
            Ton Chief of Staff intelligent
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight leading-[1.05]">
            Fais ce qui compte.<br />
            <span className="text-muted-foreground">Libère le reste.</span>
          </h1>
          <p className="mt-6 text-base sm:text-lg text-muted-foreground leading-relaxed max-w-md">
            AIRTIME transforme tes emails et ton agenda en tâches, priorités et
            temps libre protégé. Chaque matin, il répond à une seule question :
            que dois-je faire aujourd'hui — et où ai-je vraiment du temps ?
          </p>

          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="group mt-9 inline-flex items-center gap-3 rounded-full bg-primary px-7 py-3.5 text-primary-foreground font-medium
                       transition-all duration-300 hover:opacity-90 hover:gap-4"
          >
            Continuer avec Google
            <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />
          </button>
          <div className="mt-4 flex items-center gap-2 text-xs text-muted-foreground">
            <ShieldCheck className="w-3.5 h-3.5" /> OAuth sécurisé · tokens chiffrés · aucun mot de passe stocké
          </div>
        </motion.div>

        <div className="relative z-10 flex flex-wrap gap-x-8 gap-y-3 text-sm text-muted-foreground">
          {[["Aujourd'hui", Sun], ["Inbox IA", Inbox], ["Agenda protégé", Calendar], ["Assistant", Sparkles]].map(
            ([label, Icon]) => (
              <div key={label} className="flex items-center gap-2">
                <Icon className="w-4 h-4 text-primary" /> {label}
              </div>
            )
          )}
        </div>
      </div>

      {/* Right — visual */}
      <div className="relative hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1697373958725-4b83d31c4649?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxnb2xmJTIwY291cnNlJTIwc2VyZW5lJTIwZm9nZ3klMjBtb3JuaW5nJTIwaGVyb3xlbnwwfHx8fDE3OTAwMDYyOTF8MA&ixlib=rb-4.1.0&q=85"
          alt="Parcours de golf au petit matin"
          className="absolute inset-0 h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent" />
        <div className="absolute bottom-10 left-10 right-10 glass rounded-2xl p-6">
          <div className="font-mono text-xs uppercase tracking-widest text-emerald-400">Créneau golf · Jeudi</div>
          <div className="mt-2 font-display text-2xl font-semibold">08h30 — 14h00</div>
          <div className="text-sm text-muted-foreground mt-1">
            Aucun rendez-vous. Ta première deadline sérieuse est vendredi.
          </div>
        </div>
      </div>
    </div>
  );
}
